export default __webpack_public_path__ + "static/media/haiti.47a03763.svg";